/* eslint-disable react/prop-types */
import React from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../css/Warehouse.css';
import { Route, Switch } from 'react-router-dom';
import FormAddUserGroup from './FormAddUserGroup';
import ListUserGroup from './ListUserGroup';
import MyUtil from '../../functions/MyUtil';

const UserGroup = ({ match }) => {
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListUserGroup match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route path={`${match.url}/add`} component={FormAddUserGroup} />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/edit/:user_group_id`}
            component={FormAddUserGroup}
          />
        )}
      </Switch>
    </div>
  );
};

export default UserGroup;
